import satisfies from 'semver/functions/satisfies';
/**
 * @name validateUnraidVersion
 * @description Determine if provided Unraid OS Version satifies minimum and recommended OS versions
 * @param {string} unraidVersion
 * @param {string} minVersion
 * @param {string} recommendedVersion
 * @return {boolean}
 */
const validateUnraidVersion = (unraidVersion, minVersion, recommendedVersion) => {
  const greaterThanMinLessThanRecommended = satisfies(
    unraidVersion,
    `>=${minVersion} <${recommendedVersion}`,
    {
      includePrerelease: false,
    },
  );

  if (greaterThanMinLessThanRecommended) {
    return true;
  }

  const greaterThanOrEqualToRecommended = satisfies(
    unraidVersion,
    `>=${recommendedVersion}`,
    {
      includePrerelease: true,
    },
  );

  if (greaterThanOrEqualToRecommended) {
    return true;
  }

  return false;
};

export default validateUnraidVersion;
